var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShow && !_vm.withCard
    ? _c("i", {
        staticClass: "mdi mdi-spin mdi-autorenew mdi-48px text-primary"
      })
    : _vm.shouldShow && _vm.withCard
    ? _c("div", { staticClass: "card shadow-sm" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("i", {
        staticClass: "mdi mdi-spin mdi-autorenew mdi-48px text-primary"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }